import router               from '@/router';
import store                from '@/store';
import { Bar }              from 'vue-chartjs'
import DashBoardDataService from './services/DashBoardDataService';

import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js'

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend)

export default {

    name: 'Painel',

    components: { Bar },

    data: () => ({
        beginYear: 2023,
        chartData: {
            labels: [
                'Janeiro',
                'Fevereiro',
                'Marco',
                'Abril',
                'Maio',
                'Junho',
                'Julho',
                'Agosto',
                'Setembro',
                'Outubro',
                'Novembro',
                'Dezembro'
            ],
            datasets: []
        },
        charOptions: {
            responsive: true,
            maintainAspectRatio: false
        },
        loadingNQ: true,
        loadingNS: true,
        loadingNT: true,
        nQuestions: '',
        nStudents: '',
        nTests: '',
        nTestsbyMonth: '',
        selectedYear: '',
        years: [],
    }),

    mounted() {
        if (store.state.userType === 'aluno') {
            router.replace('/Aluno/Dashboard');
            return;
        }
        if (store.state.userType === 'administrador_sistema') {
            router.replace('/AdminSistema');
            return;
        }

        this.createYearsArray(this.beginYear);
        this.getQuestions();
        this.getStudents();
        this.getTests();
        this.getTestsbyMonth();
    },

    computed: {
        currentYear() {
            return this.selectedYear;
        },
    },

    watch: {
        currentYear() {
            this.getTestsbyMonth();
        },
    },

    methods: {

        createYearsArray(beginYear) {
            const actualYear = new Date().getFullYear();

            for (let year = beginYear; year <= actualYear; year++) {
                this.years.push(year);
            }
            this.selectedYear = actualYear;
        },

        async getQuestions() {
            try {
                const response  = await DashBoardDataService.nQuestions();
                this.loadingNQ  = false;
                this.nQuestions = response.data;
            } catch (error) {
                console.error(error);
            }
        },

        async getStudents() {
            try {
                const response = await DashBoardDataService.nStudents();
                this.loadingNS = false;
                this.nStudents = response.data;
            } catch (error) {
                console.error(error);
            }
        },

        async getTests() {
            try {
                const response = await DashBoardDataService.nTests();
                this.loadingNT = false;
                this.nTests    = response.data;
            } catch (error) {
                console.error(error);
            }
        },

        async getTestsbyMonth() {
            try {
                const response = await DashBoardDataService.nTestsbyMonth({ year: this.selectedYear });
                this.chartData = {
                    labels: this.chartData.labels,
                    datasets: [
                        {
                            label: 'Atividades avaliativas por mes',
                            backgroundColor: '#3C6E8F',
                            data: response.data,
                        }
                    ]
                };
            } catch (error) {
                console.error(error);
            }
        },
    }
};
